module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "h2",
    attrs: {
      "id": "p55"
    }
  }, [_c('span', [_c('a', {
    attrs: {
      "href": "#/Contents#rp55"
    }
  }, [_vm._v("SPINACH SOUP")])])]), _vm._v(" "), _c('p', {
    staticClass: "imagel"
  }, [_c('span', [_c('img', {
    attrs: {
      "alt": "",
      "height": "5",
      "src": "images/line-3.jpg",
      "width": "532"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "normal"
  }, [_c('span', [_c('i', [_vm._v("This soup is best eaten as soon as its cooked, as the color will change as it stands.")])])]), _vm._v(" "), _c('p', {
    staticClass: "make"
  }, [_c('span', [_vm._v("10 first-course servings")])]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('span', [_vm._v("1 large leek (white part only) thinly sliced")])]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('span', [_vm._v("⅓ cup each: sliced carrot, celery")])]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('span', [_vm._v("1 tablespoon olive oil")])]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('span', [_vm._v("2 quarts Rich Chicken Stock (see "), _c('a', {
    attrs: {
      "href": "#/Chapter014#p4"
    }
  }, [_vm._v("p. 4")]), _vm._v(")")])]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('span', [_vm._v("2 pounds fresh spinach")])]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('span', [_vm._v("Salt and pepper, to taste")])]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('span', [_vm._v("½ cup (2 ounces) grated Parmesan cheese")])]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('span', [_vm._v("Croutons (see "), _c('span', {
    attrs: {
      "href": "#/Chapter131#p849",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("p. 636")]), _vm._v(")")])]), _vm._v(" "), _c('p', {
    staticClass: "normalt"
  }, [_c('span', [_c('a', {
    attrs: {
      "id": "page_42"
    }
  }), _c('b', [_vm._v("1.")]), _vm._v(" Sauté leek, carrot, and celery in oil in large saucepan until tender, about 8 minutes; add stock and heat to boiling. Add spinach and cook, uncovered, until wilted, about 2 minutes. Process soup in food processor or blender until smooth; season to taste with salt and pepper. Sprinkle each bowl of soup with Parmesan cheese and croutons.")])]), _vm._v(" "), _c('p', {
    staticClass: "per"
  }, [_c('span', [_vm._v("Per Serving:")])]), _vm._v(" "), _c('p', {
    staticClass: "per1"
  }, [_c('span', [_vm._v("Calories: 113")])]), _vm._v(" "), _c('p', {
    staticClass: "per1"
  }, [_c('span', [_vm._v("% calories from fat: 31")])]), _vm._v(" "), _c('p', {
    staticClass: "per1"
  }, [_c('span', [_vm._v("Protein (g): 9.1")])]), _vm._v(" "), _c('p', {
    staticClass: "per1"
  }, [_c('span', [_vm._v("Carbohydrate (g): 9.9")])]), _vm._v(" "), _c('p', {
    staticClass: "per1"
  }, [_c('span', [_vm._v("Fat (g): 3.8")])]), _vm._v(" "), _c('p', {
    staticClass: "per1"
  }, [_c('span', [_vm._v("Saturated fat (g): 1.2")])]), _vm._v(" "), _c('p', {
    staticClass: "per1"
  }, [_c('span', [_vm._v("Cholesterol (mg): 4")])]), _vm._v(" "), _c('p', {
    staticClass: "per1"
  }, [_c('span', [_vm._v("Sodium (mg): 229")])]), _vm._v(" "), _c('p', {
    staticClass: "per"
  }, [_c('span', [_vm._v("Exchanges:")])]), _vm._v(" "), _c('p', {
    staticClass: "per1"
  }, [_c('span', [_vm._v("Milk: 0.0")])]), _vm._v(" "), _c('p', {
    staticClass: "per1"
  }, [_c('span', [_vm._v("Vegetable: 2.0")])]), _vm._v(" "), _c('p', {
    staticClass: "per1"
  }, [_c('span', [_vm._v("Fruit: 0.0")])]), _vm._v(" "), _c('p', {
    staticClass: "per1"
  }, [_c('span', [_vm._v("Bread: 0.0")])]), _vm._v(" "), _c('p', {
    staticClass: "per1"
  }, [_c('span', [_vm._v("Meat: 0.5")])]), _vm._v(" "), _c('p', {
    staticClass: "per1"
  }, [_c('span', [_vm._v("Fat: 0.5")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-befbaae0","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Chapter0236.vue
// module id = 243
// module chunks = 0